module.exports = "https://static.zego.com/_next/static/images/Euro-da49180c68dbfc5382525fa4049064e7.svg";